import { Box, Button, Icon, Text } from '@fairfashion/design-system'

import * as Styles from './item-card.styles'
import { CardProps } from './item-card.types'

export const ItemCard = ({
  icon,
  iconColor,
  title,
  render,
  hasData,
  error = false,
  onClickAddButton,
}: CardProps) => {
  return (
    <Box direction="column" width="100%" gap={1}>
      <Styles.Card
        border={{ width: 1, color: `${error ? 'error' : 'grey_5'}` }}
      >
        <Box width="100%" justifyContent="space-between" alignItems="center">
          <Box alignItems="center" gap={2}>
            <Styles.IconContainer>
              <Icon name={icon} color={iconColor} size={24} />
            </Styles.IconContainer>
            <Text fontWeight={500}>{title}</Text>
          </Box>
          {onClickAddButton && (
            <Box>
              <Button
                variant="text"
                padding="0"
                color="grey_3"
                onClick={onClickAddButton}
              >
                {!hasData ? (
                  <>
                    Adicionar
                    <Icon name="add" color="grey_3" size={16} />
                  </>
                ) : (
                  <Icon name="arrow_left_right" size={24} color="grey_3" />
                )}
              </Button>
            </Box>
          )}
        </Box>
        {render}
      </Styles.Card>
      {error && (
        <Text color="error" size="small">
          * Preenchimento obrigatório
        </Text>
      )}
    </Box>
  )
}
